import { usePaymentContext } from '../PaymentContext';
import { useNewCardFormContext } from './useNewCardFormContext';
import { useSelectCardFormContext } from './useSelectCardFormContext';

export function usePaymentFormContext() {
	const { newCard } = usePaymentContext();
	const newCardFormContext = useNewCardFormContext();
	const selectCardFormContext = useSelectCardFormContext();

	return newCard ? newCardFormContext : selectCardFormContext;
}
